<template>
  <div>
    <div class="example" v-if="tahmini_katilimci_is_loaded === false">
      <nodatayet v-if="noDataYet === true"></nodatayet>
      <div v-else>
        <b-button class="ml-3 d-flex" variant="outline-primary" @click="refreshBtn">
          <b-icon icon="arrow-clockwise"></b-icon>
        </b-button>
        <apexchart
            height="450px"
            ref="donut"
            :options="chartOptions"
            :series="series"
        ></apexchart>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>


<script>
import ApexCharts from 'vue-apexcharts'
import loading from "@/components/LoadingSpiner";
import nodatayet from "@/components/NoDataYet";
import axios from "axios";

export default {
  name: 'apex_tahmini_katilimci',
  components: {
    apexchart: ApexCharts,
    loading,
    nodatayet,
  },
  props: ['y_mesaj'],
  data() {
    return {
      //response ile gelecek verileri tutacak degiskenler
      tahmini_katilimci_is_loaded: true,
      noDataYet: true,
      response: null,
      x_axis_data: [],
      saat: [],
      //apex chartin degiskenleri
      series: [{
        name: 'series-1',
        data: null,
      }],
      noData: {
        text: "Loading..."
      },
      chartOptions: {
        series: null,
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: 90,
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transperan']
        },
        colors: ['#8B0000'],
        xaxis: {
          max: '90%',
          labels: {
            router: -45
          },
          categories: [],
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: this.y_mesaj,
          },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {}
        }
      },
    }
  },
  created() {
    this.tahminiKatilimciRaporunuGetir()
  },

  methods: {
    refreshBtn() {
      this.tahminiKatilimciRaporunuGetir()
    },
    async tahminiKatilimciRaporunuGetir() {
      this.tahmini_katilimci_is_loaded = true
      try {
        this.response = await axios.get('rapor/tahmini-katilimci/', {
          baseURL: "https://bbbservis.hayrategitim.com/api/"
        })
        if (this.response.data == null) {
          this.noDataYet = true
          this.tahmini_katilimci_is_loaded = false
          return
        }
        this.noDataYet = false
        this.tahmini_katilimci()
      } catch (e) {
        this.showErrorMessageToast(e)
      }
    },
    //response den gelen verileri degiskenlere atanmasi
    tahmini_katilimci() {
      this.x_axis_data = []
      this.saat = []
      try {
        const data = this.response.data
        data.forEach((value, index) => {
          this.x_axis_data.push(value.katilimci_adedi)
          this.saat.push(value.saat)
        })
        this.series = []
        this.chartOptions.series = []
        this.fill_tahmini_katilimci()
      } catch (e) {
        this.showErrorMessageToast(e)
      }
      this.tahmini_katilimci_is_loaded = false
    },
    // degiskenlerdeki verileri apex chart degiskenlerine doldurma
    fill_tahmini_katilimci() {
      this.series = [{
        name: 'Tahmini Katilimci: ',
        data: this.x_axis_data,
      }]
      this.chartOptions.xaxis.categories = this.saat
    },
  }
}
</script>